function search() {
  $('.search_per_page button').click(function() {
    let url = new URL(window.location.href);
    let perpage = $(this).attr('data-value');
    url.searchParams.set('posts_per_page', perpage);
    window.location.href = url;
  });

  $('.category-ct').on('click', 'h3', function(){
    let $categoryCt = $(this).closest('.category-ct');
    $categoryCt.find('.categories-list').slideToggle();
    $categoryCt.toggleClass('not-deployed');
  });

  //Remove * character in category search
  $('.category-ct .category-name').each(function() {
    let text = $(this).text();
    if (text.charAt(0) == '*')
      $(this).text(text.substring(1));
  });

  $('.mobile-search-sidebar .category-ct .categories-list').slideUp();
  $('.mobile-search-sidebar .category-ct').addClass('not-deployed');

  $('.mobile-search-sidebar').on('click', '.search-menu button', function() {
    $('.mobile-mymantion--nav').removeClass('deployed');
    $('.mobile-menu').removeClass('deployed');

    if ($(this).attr('data-deploy') == 'filters') {
      $('.search-content .filters').toggle();
      $('.search-content .ordering').hide();
    } else {
      $('.search-content .ordering').toggle();
      $('.search-content .filters').hide();
    }
  });

  $('.category-ct .category-title').on('click', function () {
    let $categoryCt = $(this).closest('.category-ct');
    $categoryCt.find('.categories-list').slideToggle();
    $categoryCt.toggleClass('not-deployed');
  });

  $('button.see-products').on('click', function() {
    $('.search-menu button[data-deploy="filters"]').trigger('click');
  });

/*   $('.mobile-only .mantion-top-search').click(function() {
    if (window.innerWidth <= 1024) {
      $.fancybox.open({
        src  : '#modal-search-mobile',
        type : 'inline',
        touch: false,
      });
    }
  }); */

  //Trigger search on click
  $('.submit-search-btn').click(function() {
    $(this).closest('.mantion-top-search').find('.woocommerce-product-search').submit();
  });

  // Go back to top of page when page changed.
  $(document).on('click', '.facetwp-page[data-page]', function () {
    $(window).scrollTop(0);
  })
}

function removeParam(key, sourceURL) {
  var rtn = sourceURL.split("?")[0],
      param,
      params_arr = [],
      queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
  if (queryString !== "") {
      params_arr = queryString.split("&");
      for (var i = params_arr.length - 1; i >= 0; i -= 1) {
          param = params_arr[i].split("=")[0];
          if (param === key) {
              params_arr.splice(i, 1);
          }
      }
      rtn = rtn + "?" + params_arr.join("&");
  }
  return rtn;
}

export { search };
